import { myApi } from "../config/axiosConfig";
import { useQuery } from "@tanstack/react-query";

export const useUserStats = ( start, end ) => {

    return useQuery({

        queryKey: ["usetStats", start ?? null, end ?? null],
        queryFn: async () => {
            
            const payload = {
                start: start,
                end: end
            }
            
            const { data } = await myApi.post(`/events/user/stats`, payload);

            return data;

        },

    })

}

export const useUserEvents = ( user, start, end ) => {

    return useQuery({

        queryKey: ["usetStats", user ?? null, start ?? null, end ?? null],
        queryFn: async () => {
            
            const payload = {
                user: user,
                start: start,
                end: end
            }
            
            const { data } = await myApi.post(`/events/user/events`, payload);

            return data;

        },
        enabled: !!user

    })

}